import { Component, OnInit } from '@angular/core';
import { Scene } from 'src/app/models/Scene';
import { ModalController, AlertController } from '@ionic/angular';
import { ValidationService } from 'src/app/services/validation.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';

@Component({
  selector: 'app-add-scene-modal',
  templateUrl: './add-scene-modal.page.html',
  styleUrls: ['./add-scene-modal.page.scss'],
})
export class AddSceneModalPage implements OnInit {

  scene: Scene;
  isEditing: boolean;

  constructor(
    public modalController: ModalController,
    public alertController: AlertController,
    public validationService: ValidationService,
    public unfocusService: UnfocusElementService
  ) { }

  ngOnInit() {
    document.querySelector('#scene-name-input').focus();
  }

  closeModal() {
    this.modalController.dismiss();
  }

  saveScene(event) {
    this.unfocusService.unfocus(event);
    this.scene.name = this.validationService.removeHtmlTags(this.scene.name);
    if (!this.validationService.isEmptyOrNull(this.scene.name)) {
      this.modalController.dismiss(this.scene);
    } else {
      this.alertForSceneName();
    }
  }

  async alertForSceneName() {
    const alert = await this.alertController.create({
      header: 'Scene Name Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

}